import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  return <section className="py-24 px-4 bg-brand-text text-center" data-id="element-57" data-mp="3n2tev3e5nw8e">
      <div className="max-w-3xl mx-auto" data-id="element-58" data-mp="3n563u0ibz6uy">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-10" data-id="element-59" data-mp="3s1mtiz56hta5">
          ¿Estás listo para recuperar tus domingos?
        </h2>
        <CTAButton className="text-base md:text-lg py-5 px-10 mb-4 w-full sm:w-auto" data-id="element-60" data-mp="vczqi2et05e" />
        <p className="text-sm text-white/70 font-medium" data-id="element-61" data-mp="2zetklthmxnp2">
          $19.990 &middot; Pago único &middot; Descarga inmediata
        </p>
      </div>
    </section>;
}